import React, { useState, useEffect, useContext,useRef } from 'react';
//import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { FirebaseContext } from 'common';
import { useTranslation } from "react-i18next";
import AlertDialog from '../components/AlertDialog';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment/min/moment-with-locales';
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import MaterialTable from "@material-table/core";

export default function Subscriptions() {
  const { api } = useContext(FirebaseContext);
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    editSubscriptions
  } = api;
  const userdata = useSelector(state => state.usersdata);
  const [drivers, setDrivers] = useState();
  const [driversObj, setDriversObj] = useState();
  const [data, setData] = useState();
  const subscriptiondata = useSelector(state => state.subscriptiondata);
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [stypes,setStypes] = useState({});
  const [stypesObj,setStypesObj] = useState({});

  useEffect(() => {
    if (subscriptiondata.subscriptions) {
      setData(subscriptiondata.subscriptions);
    } else {
      setData([]);
    }
  }, [subscriptiondata.subscriptions]);

  useEffect(() => {
    if (userdata.users) {
      let arr =  [];
      userdata.users.filter(user => user.usertype==='driver').map((user)=> arr.push(
        {id: user.id, desc:user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden")}
      ))
      setDrivers(arr);
      let obj =  {};
      userdata.users.filter(user => user.usertype==='driver').map((user)=> obj[user.id]=user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden"),)
      setDriversObj(obj);
    } else {
     setData([]);
    }
  }, [userdata.users,settings.AllowCriticalEditsAdmin]);

  useEffect(() => {
    if (subscriptiondata.subscription_types) {
      let obj =  {};
      let obj2 =  {};
      subscriptiondata.subscription_types.map((sub)=> obj[sub.id]=sub.name)
      setStypes(obj);
      subscriptiondata.subscription_types.map((sub)=> obj2[sub.id]=sub)
      setStypesObj(obj2);
    } else {
      setData([]);
    }
  }, [subscriptiondata.subscription_types]);


  const columns = [
    { title: t('createdAt'), field: 'createdAt', editable:'never', render: rowData => rowData.createdAt?moment(rowData.createdAt).format('lll'):null,cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'},
      exportTransformer: (rowData) => new Date(rowData.createdAt).toLocaleDateString() + ' '+ new Date(rowData.createdAt).toLocaleTimeString()},
    { title: t('driver'), field: 'driver', editable:'onAdd', cellStyle:{ textAlign: 'center'}, 
      render: rowData =>{
          if (rowData && rowData.driver) {
            return driversObj[rowData.driver]
          }
      },
      editComponent: props => (
        <Autocomplete
          id="combo-box-demo"
          options={drivers}
          getOptionLabel={(option) => option.desc}
          style={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Combo box" variant="outlined" />}
          onChange={(event, newValue) => {
            props.onChange(newValue.id)
          }}
        />
      ),
      exportTransformer: (rowData) => driversObj[rowData.driver],
    },
    { title: t('subscription_type'), field: 'subscription_type', cellStyle:{ textAlign: 'center'},lookup: stypes},
    { title: t('start_date'), field: 'start_date', type: 'datetime', render: rowData => rowData.start_date?moment(rowData.start_date).format('lll'):null,cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'},
      exportTransformer: (rowData) => new Date(rowData.start_date).toLocaleDateString() + ' '+ new Date(rowData.start_date).toLocaleTimeString()},
    { title: t('end_date'), field: 'end_date', editable:'never', type: 'date', render: rowData => rowData.end_date?moment(rowData.end_date).format('lll'):null,cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'},
     exportTransformer: (rowData) => new Date(rowData.end_date).toLocaleDateString() + ' '+ new Date(rowData.end_date).toLocaleTimeString()},
    { title: t('numdays'), field: 'numdays', editable:'never', type: 'numeric', cellStyle:{ textAlign: 'center'}},
    { title: t('amount'), field: 'amount', editable:'never', type: 'numeric', cellStyle:{ textAlign: 'center'}}
  ];


  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const editData = (newData,method) => {
    return settings.AllowCriticalEditsAdmin?
    new Promise((resolve, reject)=> {
      let nowDate = new Date().getTime();
      let startDate = newData.start_date? new Date(newData.start_date).getTime():nowDate; 
      let finalDate = 0;
      data.filter(sub =>  method === 'Add'? (sub.driver===newData.driver) : ( sub.driver===newData.driver && sub.id !== newData.id)).map((sub)=> finalDate = sub.end_date > finalDate ? sub.end_date : finalDate)
      if(nowDate> startDate || finalDate> startDate){
        alert(t('invalid_date'));
        reject();
      } else {
        setTimeout(() => {
          if(method === 'Add'){
            newData['createdAt'] = new Date().getTime();
          }
          if(newData.hasOwnProperty('approved')){
            delete newData.approved;
          }
          newData['start_date'] = new Date(newData.start_date).getTime();
          newData['end_date'] = (new Date(newData.start_date).getTime()) + (parseFloat(stypesObj[newData.subscription_type].numdays) * 24 * 60 * 60 * 1000);
          newData['numdays'] = stypesObj[newData.subscription_type].numdays;
          newData['amount'] = stypesObj[newData.subscription_type].amount;
          dispatch(editSubscriptions(newData,method));
          resolve();
        }, 600);
      }
  })
    :
    new Promise(resolve => {
      setTimeout(() => {
        resolve();
        alert(t('demo_mode'));
      }, 600);
    })
  }

  return (
    subscriptiondata.loading ? <CircularLoading /> :
    <div ref={rootRef}>
      <MaterialTable
        title={t('subscriptions')}
        columns={columns}
        data={data}
        style={{direction:isRTL ==='rtl'?'rtl':'ltr'}}
        options={{
          exportMenu: [
            {
              label: "Export PDF",
              exportFunc: (cols, datas) => ExportPdf(cols, datas, "Subscription_Report")
            },
            {
              label: "Export CSV",
              exportFunc: (cols, datas) => ExportCsv(cols, datas, "Subscription_Report")
            }
          ],
          search: false,
          exportButton: true,
        }}
        localization={{body:{
          addTooltip: (t('add')),
          deleteTooltip: (t('delete')),
          editTooltip: (t('edit')),
          emptyDataSourceMessage: (
            (t('blank_message'))
        ),
        editRow: { 
          deleteText: (t('delete_message')),
          cancelTooltip: (t('cancel')),
          saveTooltip: (t('save')) 
           }, 
          },
          toolbar: {
            searchPlaceholder: (t('search')),
            exportTitle: (t('export')),
          },
          header: {
            actions: (t('actions')) 
        },
        pagination: {
          labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
          //labelRowsSelect: (t('rows')),
          firstTooltip: (t('first_page_tooltip')),
          previousTooltip: (t('previous_page_tooltip')),
          nextTooltip: (t('next_page_tooltip')),
          lastTooltip: (t('last_page_tooltip'))
        },
        }}
        editable={{
          onRowAdd: newData => editData(newData,"Add") ,
          onRowUpdate: (newData, oldData) => editData(newData,"Edit"),
          onRowDelete: oldData =>
            settings.AllowCriticalEditsAdmin?
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                dispatch(editSubscriptions(oldData,"Delete"));
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 600);
            })
        }}
      />
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div>
  );
}
